import UserActionTypes from "./user.types";

// const INITIAL_STATE = { userId: null, username: null };
const INITIAL_STATE = {
  currentUser: null,
  isSessionValid : false
};

// export default (state = INITIAL_STATE, { type, user }) => {
//   Object.freeze(state);
//   switch (type) {
//     case UserActionTypes.RECEIVE_CURRENT_USER:
//       return user;
//     case UserActionTypes.LOGOUT_CURRENT_USER:
//       return _nullSession;
//     default:
//       return state;
//   }
// };

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.SET_SESSION_VALIDATED:
      return{...state,...action.payload}
    case UserActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload
      };
    case UserActionTypes.LOGOUT_CURRENT_USER:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default userReducer;
